import {get} from 'lodash';
import refactorRespImg from '../../ui/resp-img';
import replaceWithCDN from '../../util/replaceWithCDN';
export default data => {
  return {
    background: get(data, 'iwt2Background', null),
    preTitle: get(data, 'iwt2Pretitle', null),
    title: get(data, 'iwt2Title', null),
    text: get(data, 'iwt2Text', null),
    image: get(data, 'iwt2023Image', null) ? refactorRespImg(get(data, 'iwt2023Image', null), [{
              size: 'default',
              key: 'image_size_760x516',
            },{
              size: 'md',
              key: 'image_size_840x570',
            }]): null,
    imagePosition: get(data, 'iwt2ImagePosition', null),
    video: replaceWithCDN(get(data, 'iwt2VideoFile.guid', null)),  
    link: {
      'title': get(data, 'iwt2Link.title', null),
      'href': get(data, 'iwt2Link.url', null),
      'tagret': get(data, 'iwt2Link.target', null),
      "assignedDomains": [
        "jayco.com.au",
        "jayco.co.nz",
        "AU-dealers",
        "NZ-dealers"
      ]
    },
    cta: {
      'title': get(data, 'iwt2Cta.title', null),
      'href': get(data, 'iwt2Cta.url', null),
      'tagret': get(data, 'iwt2Cta.target', null),
      "style": "secondary"
    },
  }
}
